import { CobaltSectionMessage } from '@cae/cobalt-react/components/section-message';
import { CobaltIconCheckmarkCircleSolid } from '@cae/cobalt-react/icons/solid/CobaltIconCheckmarkCircleSolid';
import * as React from 'react';

import type { ApproveRevokeAction } from './InstructorActionFeedbackModal.types';

import styles from './InstructorActionFeedbackModal.module.css';

function getSectionMessage(
  action: ApproveRevokeAction,
  status: 'success' | 'error',
  instructorDisplayName: string
): React.ReactElement {
  const isRevoke = action === 'Revoke';

  if (isRevoke && status === 'success') {
    return (
      <CobaltSectionMessage
        variant="success"
        sectionMessageTitle={
          <h2>Revocation request received for {instructorDisplayName}</h2>
        }
      />
    );
  }
  if (isRevoke && status === 'error') {
    return (
      <CobaltSectionMessage
        variant="danger"
        sectionMessageTitle={
          <h2>
            Revocation request failed for {instructorDisplayName}. Please try
            again or contact customer care if the issue persists.
          </h2>
        }
      />
    );
  }
  if (status === 'success') {
    return (
      <CobaltSectionMessage
        variant="success"
        sectionMessageTitle={<h2>Approval request successfully submitted!</h2>}
      />
    );
  }
  return (
    <CobaltSectionMessage
      variant="danger"
      sectionMessageTitle={
        <h2>
          Approval request failed to submit. Please try again or contact
          customer care if the issue persists.
        </h2>
      }
    />
  );
}

function getBadge(action: ApproveRevokeAction): React.ReactNode {
  if (action === 'Approve') {
    return (
      <CobaltIconCheckmarkCircleSolid className={styles.badge} size="medium" />
    );
  }
  return null;
}

export { getSectionMessage, getBadge };
